import React from 'react';
import PropTypes from 'prop-types';

import PageContainer from '@deliveroo/consumer-component-library/components/PageContainer';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import styles from './styles.scss';

export function LandingPageFooter({ heading, locationSearch }) {
  return (
    <PageContainer fullWidth="always">
      <div className={styles.outerWrapper}>
        <PageContainer>
          <Spacer
            spacing={{
              mobile: 'large 0',
              tablet: 'x-large 0',
            }}
          >
            <div className={styles.innerWrapper}>
              <span className={styles.center}>
                <Heading
                  level={4}
                  color="white"
                  size="small"
                  spacing={{
                    tablet: '0 0 small 0',
                  }}
                >
                  <span className={styles.heading}>{heading}</span>
                </Heading>
              </span>
              <Spacer spacing="medium 0">{locationSearch}</Spacer>
            </div>
          </Spacer>
        </PageContainer>
      </div>
    </PageContainer>
  );
}

LandingPageFooter.propTypes = {
  heading: PropTypes.string.isRequired,
  locationSearch: PropTypes.node.isRequired,
};

export default LandingPageFooter;
